import * as React from "react";
import SumOrdered from "./SumOrdered";

export interface Props {
  children?: React.ReactNode;
}

export interface State {}

export default class OrdersPage extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {};
  }

  render() {
    return <SumOrdered />;
  }
}



// WEBPACK FOOTER //
// ./src/screens/Orders/OrdersPage.tsx